import { useCallback, useEffect } from 'react';

export default function usePasteMedia(onPasteMedia) {
  const pasteMedia = useCallback(
    (event) => {
      const clipboardDataItems = event?.clipboardData?.items;
      if (!clipboardDataItems) return;

      const files = [];
      for (const item of Array.from(clipboardDataItems)) {
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file) {
            event.preventDefault();
            files.push(file);
          }
        }
      }

      onPasteMedia(files);
    },
    [onPasteMedia],
  );

  useEffect(() => {
    document.addEventListener('paste', pasteMedia, false);
    return () => {
      document.removeEventListener('paste', pasteMedia);
    };
  }, [pasteMedia]);
}
